import React, { useEffect, useReducer, useState } from "react";
import TextInput from "../../components/Common/TextInput";
import CallOut from "../../components/Common/CallOut";
import Notification from "../../components/Common/Notification";
import { useTheme } from "../../DataStore/ThemeContext";
import { useConfig } from "../../DataStore/ConfigContext";
import ajaxConfig from "../../util/remote/ajaxConfig";

const initialState = {
  roleName: "",
  loading: false,
};

const reducer = (state, action) => {
  if (action.type === "RESET") return { ...initialState };
  return { ...state, [action.type]: action.value };
};

const NewRole = () => {
  const { setNotify, setSystemFunction } = useTheme();
  const { getUserRoles } = useConfig();

  const [info, setInfo] = useState(null);
  const [state, dispatch] = useReducer(reducer, initialState);


  useEffect(() => {
    // setSystemFunction expects a FUNCTION, not the execution result
    setSystemFunction(() => handleSave);
    return () => {
      // reset the system function when this modal unmounts
      setSystemFunction(() => () => alert("No Function Assigned"));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const handleSave = async () => {

    if (state.loading) return;

    if (!String(state.roleName || "").trim()) {
      setInfo(<Notification type="danger" message={`Role name is required. ${state.roleName}`} />);
      return;
    }

    dispatch({ type: "loading", value: true });

    const server_response = await ajaxConfig.configureNewRole({
      role_name: String(state.roleName || "").trim(),
    });

    dispatch({ type: "loading", value: false });

    if (server_response.status === "OK") {
      setInfo(<Notification type="success" message={server_response.message} />);
      setNotify(<Notification type="success" message={server_response.message} />);
      dispatch({ type: "RESET" });

      // refresh roles after notification
      setTimeout(() => getUserRoles(true), 600);

    
    } else {
      setInfo(<Notification type="danger" message={server_response.message} />);
    }
  };

    return (
    <>
      <div className="mb-4">
        <CallOut
            type="info"
            title="Best Practice: Naming Roles"
            description="Use clear, functional names like 'Accounts Clerk' or 'Admissions Officer'. This makes it easier to audit logs and assign permissions accurately later."
            />
      </div>

      {/* 2. Feedback Notification Area */}
      {info && (
        <div className="mb-4 animate__animated animate__fadeIn">
          {info}
        </div>
      )}

        <div style={{ position: 'relative' }}>

          
          <TextInput
            type="text"
            placeholder="Enter role designation..."
            leftIcon="fa fa-shield-halved" // Modern icon suggestion
            value={state.roleName}
            onChange={(e) => dispatch({ type: "roleName", value: e.target.value })}
            required
            label="New Role Designation"
            wrap
            labelStyle={{
                fontWeight: '600', 
                fontSize: '13px', 
                color: '#64748B', 
                marginBottom: '8px',
                display: 'block' 
            }}
          />
          
          <small className="form-text text-muted mt-2" style={{ fontSize: '12px' }}>
            Avoid using generic names; be specific to the job function.
          </small>
        </div>

       
    </>
  );
};

export default NewRole;
